import { concatMap, filter, from, mergeMap, Observable, scan, tap } from 'rxjs';

export function bulkOperator<T>(
  arrayOfObservable: Observable<T>[],
  onProgress?: (index: number, length: number) => void,
  parallel = false, // Default is parallel execution
  concurrency: number = arrayOfObservable.length // Limit concurrency if needed
): Observable<T[]> {
  return from(arrayOfObservable).pipe(
    parallel
      ? mergeMap((buffer) => buffer, concurrency)
      : concatMap((buffer) => buffer), // Choose execution mode
    scan<T, T[]>((acc: T[], data: T) => [...acc, data], []), // Explicitly set type
    tap((res) => {
      console.log(
        '⚠️ Bulk in progress',
        res.length,
        '/',
        arrayOfObservable.length
      );
      if (onProgress) {
        onProgress(res.length, arrayOfObservable.length);
      }
    }),
    filter((res) => res.length === arrayOfObservable.length),
    tap(() => console.log('✅ Bulk finished'))
  );
}
